// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  n8nUrl: 'https://asistente-ia.capitalkaizen.com/webhook/bd18c382-34ed-436f-8701-95e3e5740650/chat',
  apiUrl: 'https://backoffice-dev.kaizenwp.com/api/v1/',
  termsPDF: 'https://backoffice-dev.kaizenwp.com/tyc/Kaizen_Terminos_y_Condiciones_Membresia.pdf'
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
